import { useEffect, useState } from 'react';

const webkitIsFullScreen = () =>
  'webkitIsFullScreen' in document && Boolean(document.webkitIsFullScreen);

const webkitFullscreenElement = () =>
  'webkitFullscreenElement' in document
    ? document.webkitFullscreenElement
    : undefined;

export const useFullscreen = (shouldKeepFullscreen = true): boolean => {
  const fullscreenDefault =
    shouldKeepFullscreen &&
    Boolean(document.fullscreenElement || webkitIsFullScreen());
  const [isFullscreen, setIsFullscreen] = useState(fullscreenDefault);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const fullscreenElement =
        document.fullscreenElement || webkitFullscreenElement();

      setIsFullscreen(Boolean(fullscreenElement));
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener(
        'webkitfullscreenchange',
        handleFullscreenChange,
      );
    };
  }, []);

  return isFullscreen;
};
